(function() {
  'use strict';

  function initZenWidgets() {
    document.querySelectorAll('.zen-clinical-widget').forEach(function(widget) {
      if (widget.dataset.zenInit) return;
      widget.dataset.zenInit = '1';

      var form = widget.querySelector('.zen-form');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var options = widget.querySelectorAll('.z-option');

      options.forEach(function(opt) {
        opt.addEventListener('click', function() {
          options.forEach(function(o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          if (variantInput) variantInput.value = opt.getAttribute('data-variant-id');
          if (qtyInput) qtyInput.value = opt.getAttribute('data-qty');
        });
      });

      var uid = widget.getAttribute('data-zen-uid');
      var infoBtn = widget.querySelector('[data-zen-info="' + uid + '"]');
      var popover = widget.querySelector('[data-zen-popover="' + uid + '"]');
      if (infoBtn && popover) {
        infoBtn.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          popover.classList.toggle('active');
        });
      }

      var stockEl = widget.querySelector('[data-zen-stock="' + uid + '"]');
      if (stockEl) {
        var now = new Date(), day = now.getDay(), hour = now.getHours();
        var text = 'Sendes i dag';
        if (day === 6 || day === 0 || (day === 5 && hour >= 15)) text = 'Sendes mandag';
        else if (day >= 1 && day <= 4 && hour >= 15) text = 'Sendes i morgen';
        stockEl.innerHTML = "På lager - <strong class='z-stock-bold'>" + text + "</strong>";
      }

      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          var mainTextEl = btn.querySelector('.z-cta-main');
          var originalText = mainTextEl.innerText;
          mainTextEl.innerText = 'Sikrer ordre...';
          btn.classList.add('loading');

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: new FormData(form)
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            btn.classList.remove('loading');
            mainTextEl.innerText = 'Lagt i kurv!';
            setTimeout(function() { mainTextEl.innerText = originalText; }, 2000);
            // Open the native Zenoura drawer (refreshed). No Qikify dependency.
            if (window.ZenCart && typeof window.ZenCart.refreshAndOpen === 'function') {
              window.ZenCart.refreshAndOpen();
            } else {
              window.location.href = window.Shopify.routes.root + 'cart';
            }
          })
          .catch(function(err) {
            console.error('Cart Error:', err);
            btn.classList.remove('loading');
            mainTextEl.innerText = 'Prøv igen';
          });
        });
      }
    });
  }

  function initZenAccordions() {
    document.querySelectorAll('[data-zen-toggle]').forEach(function(header) {
      if (header.dataset.zenInit) return;
      header.dataset.zenInit = '1';
      header.addEventListener('click', function() {
        var item = header.parentElement;
        var body = item.querySelector('.zen-acc-body');
        var isActive = item.classList.contains('active');
        var parent = item.parentElement;
        parent.querySelectorAll('.zen-acc-item').forEach(function(other) {
          other.classList.remove('active');
          var b = other.querySelector('.zen-acc-body');
          if (b) b.style.maxHeight = null;
        });
        if (!isActive) {
          item.classList.add('active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    var active = document.querySelector('.zen-acc-item.active .zen-acc-body');
    if (active) active.style.maxHeight = active.scrollHeight + 'px';
  }

  document.addEventListener('click', function(e) {
    document.querySelectorAll('.z-popover.active').forEach(function(pop) {
      if (!e.target.closest('.z-trust-banner-container')) pop.classList.remove('active');
    });
  });

  function initAll() {
    initZenWidgets();
    initZenAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();